import React from 'react';
import '../App.css';
import {
    Row,
    Col,
    Button
} from 'bootstrap-4-react';
import gift from '../gift2.png'

function Gift() {
    
  return (
    <Row id="gRow" style={{alignItems: "center"}}>
        <Col col="md-4">
            <h3 className="rowTitle">Для вас есть подарки</h3>
            <p>Для участников нашего вебинара мы подготовили полезные подарки.</p> 
            <p>Прежде всего, мы подарим самое дорогое, что у нас есть: технологическую карту механизированного нанесения декоративной штукатурки.
                 Есть еще несколько подарков, о которых вы узнаете на вебинаре.</p>
            <Button className="mb-3" success as="a" href="#cRow">Зарегистрироваться на вебинар</Button>
        </Col>
        <Col col="md-8">
            <img src={gift} alt='gift' />
        </Col>
    </Row>
          
      
    
  );
}

export default Gift;